import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { AutorizacionesAccordionPrescriptor } from "./Accordions/AutorizacionesAccordionPrescriptor";
import { AutorizacionesAccordionMateriales } from "./Accordions/AutorizacionesAccordionMateriales";

import { setearValorEnPractica } from "../../../actions/autorizaciones/Autorizaciones";

const PracticaTipoSolMaterialesSinPracticas = (props) => {
  const dispatch = useDispatch();
  const { solicitudSeleccionada } = useSelector((state) => state.autorizaciones);

  return (
    <div style={{ marginBottom: "2.8rem" }}>
      <AutorizacionesAccordionPrescriptor
        disabled={props.disabled}
        prePrescriptor={
          !!props.practica.idPrescriptor ? props.practica.prescriptor : null
        }
        setearEfector={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              props.practica.idCodNom,
              "idPrescriptor",
              idEfector
            )
          );
        }}
        estaCorrecto={props.tieneIdPrescriptor}
        esDenunciaInternacion={props.esDenunciaInternacion}
        practica={props.practica}
      />
      {props.mostrarMateriales && (
        <AutorizacionesAccordionMateriales
          practica={props.practica}
          disabled={props.disabled}
          desdeAuditar={props.desdeAuditar}
          estaCorrecto={props.tieneMinimoUnMaterial}
          esDenunciaInternacion={props.esDenunciaInternacion}
          idTipoSolicitud={solicitudSeleccionada?.idTipoSolicitud}
          evaluarPracticasMateriales={props.evaluarPracticasMateriales}
        />
      )}
    </div>
  );
};

export default PracticaTipoSolMaterialesSinPracticas;
